export default "__VITE_ASSET__3f9dec10__"